function preventArrowUpDown(event) {
  if (!event || !event.code) return;
  if (event.code === 'ArrowDown' || event.code === 'ArrowUp') {
    event.preventDefault();
  }
}

export { preventArrowUpDown };
